// noScratches: "新品同等傷なし",
// someScratches: "若干傷あり",
// noticeableScratches: "目立つ傷あり",
// crackedScreen: "画面割れ",

export const PurchaseData = [
  {
    id: 15,
    series: "iPhone15シリーズ",
    model: [
      {
        id: 151,
        name: "iphone15",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~108,000円",
            someScratches: "~90,000円",
            noticeableScratches: "",
            crackedScreen: "~70,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~120,000円",
            someScratches: "~100,000円",
            noticeableScratches: "",
            crackedScreen: "~80,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~147,000円",
            someScratches: "~111,000円",
            noticeableScratches: "",
            crackedScreen: "~90,000円",
          },
        ],
      },
      {
        id: 152,
        name: "iphone15 plus",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~108,000円",
            someScratches: "~90,000円",
            noticeableScratches: "",
            crackedScreen: "~70,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~120,000円",
            someScratches: "~100,000円",
            noticeableScratches: "",
            crackedScreen: "~80,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~147,000円",
            someScratches: "~111,000円",
            noticeableScratches: "",
            crackedScreen: "~90,000円",
          },
        ],
      },
      {
        id: 153,
        name: "iphone15 Pro",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~144,000円",
            someScratches: "~120,000円",
            noticeableScratches: "",
            crackedScreen: "~100,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~157,000円",
            someScratches: "~130,000円",
            noticeableScratches: "",
            crackedScreen: "~110,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~186,000円",
            someScratches: "~147,000円",
            noticeableScratches: "",
            crackedScreen: "~127,000円",
          },
          {
            id: 4,
            gb: "1TB",
            noScratches: "~206,000円",
            someScratches: "~163,000円",
            noticeableScratches: "",
            crackedScreen: "~143,000円",
          },
        ],
      },
      {
        id: 154,
        name: "iphone15 Pro Max",
        spec: [
          {
            id: 1,
            gb: "256GB",
            noScratches: "~172,000円",
            someScratches: "~158,000円",
            noticeableScratches: "",
            crackedScreen: "~135,000円",
          },
          {
            id: 2,
            gb: "512GB",
            noScratches: "~198,000円",
            someScratches: "~183,000円",
            noticeableScratches: "",
            crackedScreen: "~160,000円",
          },
          {
            id: 3,
            gb: "1TB",
            noScratches: "~218,000円",
            someScratches: "~204,000円",
            noticeableScratches: "",
            crackedScreen: "~181,000円",
          },
        ],
      },
    ],
  },
  {
    id: 14,
    series: "iPhone14シリーズ",
    model: [
      {
        id: 141,
        name: "iphone14",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~89000円",
            someScratches: "~70,000円",
            noticeableScratches: "",
            crackedScreen: "~50,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~97,000円",
            someScratches: "~80,000円",
            noticeableScratches: "",
            crackedScreen: "~60,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~111,000円",
            someScratches: "~85,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
        ],
      },
      {
        id: 142,
        name: "iphone14 plus",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~98000円",
            someScratches: "~70,000円",
            noticeableScratches: "",
            crackedScreen: "~50,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~106,000円",
            someScratches: "~80,000円",
            noticeableScratches: "",
            crackedScreen: "~60,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~111,000円",
            someScratches: "~85,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
        ],
      },
      {
        id: 143,
        name: "iphone14 Pro",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~123,000円",
            someScratches: "~85,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~138,000円",
            someScratches: "~97,000円",
            noticeableScratches: "",
            crackedScreen: "~77,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~148,000円",
            someScratches: "~111,000円",
            noticeableScratches: "",
            crackedScreen: "~91,000円",
          },
          {
            id: 4,
            gb: "1TB",
            noScratches: "~163,000円",
            someScratches: "123,000円",
            noticeableScratches: "",
            crackedScreen: "~103,000円",
          },
        ],
      },
      {
        id: 144,
        name: "iphone14 Pro Max",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~139,000円",
            someScratches: "~100,000円",
            noticeableScratches: "",
            crackedScreen: "~80,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~150,000円",
            someScratches: "~123,000円",
            noticeableScratches: "",
            crackedScreen: "~103,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~161,000円",
            someScratches: "~132,000円",
            noticeableScratches: "",
            crackedScreen: "~112,000円",
          },
          {
            id: 4,
            gb: "1TB",
            noScratches: "~177,000円",
            someScratches: "~133,000円",
            noticeableScratches: "",
            crackedScreen: "~112,000円",
          },
        ],
      },
    ],
  },
  {
    id: 99,
    series: "iPhoneSE第3世代シリーズ",
    model: [
      {
        id: 991,
        name: "iPhoneSE第3世代",
        spec: [
          {
            id: 1,
            gb: "64GB",
            noScratches: "~44,000円",
            someScratches: "~21,000円",
            noticeableScratches: "",
            crackedScreen: "~11,000円",
          },
          {
            id: 2,
            gb: "128GB",
            noScratches: "~55,000円",
            someScratches: "~33,000円",
            noticeableScratches: "",
            crackedScreen: "~23,000円",
          },
          {
            id: 3,
            gb: "256GB",
            noScratches: "~65,000円",
            someScratches: "~33,000円",
            noticeableScratches: "",
            crackedScreen: "~23,000円",
          },
        ],
      },
    ],
  },
  {
    id: 13,
    series: "iPhone13シリーズ",
    model: [
      {
        id: 131,
        name: "iphone13",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~79,000円",
            someScratches: "~53,000円",
            noticeableScratches: "",
            crackedScreen: "~40,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~89,000円",
            someScratches: "~60,000円",
            noticeableScratches: "",
            crackedScreen: "~45,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~99,000円",
            someScratches: "~60,000円",
            noticeableScratches: "",
            crackedScreen: "~45,000円",
          },
        ],
      },
      {
        id: 132,
        name: "iphone13 mini",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~74,000円",
            someScratches: "~43,000円",
            noticeableScratches: "",
            crackedScreen: "~30,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~85,000円",
            someScratches: "~50,000円",
            noticeableScratches: "",
            crackedScreen: "~35,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~95,000円",
            someScratches: "~50,000円",
            noticeableScratches: "",
            crackedScreen: "~35,000円",
          },
        ],
      },
      {
        id: 133,
        name: "iphone13 Pro",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~100,000円",
            someScratches: "~77,000円",
            noticeableScratches: "",
            crackedScreen: "~62,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~105,000円",
            someScratches: "~80,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~115,000円",
            someScratches: "~84,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
          {
            id: 4,
            gb: "1TB",
            noScratches: "~120,000円",
            someScratches: "85,000円",
            noticeableScratches: "",
            crackedScreen: "~65,000円",
          },
        ],
      },
      {
        id: 134,
        name: "iphone13 Pro Max",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~115,000円",
            someScratches: "~81,000円",
            noticeableScratches: "",
            crackedScreen: "~66,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~123,000円",
            someScratches: "~85,000円",
            noticeableScratches: "",
            crackedScreen: "~69,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~128,000円",
            someScratches: "~86,000円",
            noticeableScratches: "",
            crackedScreen: "~69,000円",
          },
          {
            id: 4,
            gb: "1TB",
            noScratches: "~133,000円",
            someScratches: "~87,000円",
            noticeableScratches: "",
            crackedScreen: "~69,000円",
          },
        ],
      },
    ],
  },
  {
    id: 12,
    series: "iPhone12シリーズ",
    model: [
      {
        id: 121,
        name: "iphone12",
        spec: [
          {
            id: 1,
            gb: "64GB",
            noScratches: "~62,000円",
            someScratches: "~35,300円",
            noticeableScratches: "",
            crackedScreen: "~23,500円",
          },
          {
            id: 2,
            gb: "128GB",
            noScratches: "~71,000円",
            someScratches: "~43,000円",
            noticeableScratches: "",
            crackedScreen: "~28,000円",
          },
          {
            id: 3,
            gb: "256GB",
            noScratches: "~81,000円",
            someScratches: "~46,000円",
            noticeableScratches: "",
            crackedScreen: "~31,000円",
          },
          {
            id: 4,
            gb: "512GB",
            noScratches: "~81,000円",
            someScratches: "~46,000円",
            noticeableScratches: "",
            crackedScreen: "~31,000円",
          },
        ],
      },
      {
        id: 122,
        name: "iphone12 mini",
        spec: [
          {
            id: 1,
            gb: "64GB",
            noScratches: "~52,000円",
            someScratches: "~30,500円",
            noticeableScratches: "",
            crackedScreen: "~18,500円",
          },
          {
            id: 2,
            gb: "128GB",
            noScratches: "~72,000円",
            someScratches: "~38,000円",
            noticeableScratches: "",
            crackedScreen: "~23,000円",
          },
          {
            id: 3,
            gb: "256GB",
            noScratches: "~71,000円",
            someScratches: "~40,000円",
            noticeableScratches: "",
            crackedScreen: "~25,000円",
          },
        ],
      },
      {
        id: 123,
        name: "iphone12 Pro",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~61,000円",
            someScratches: "~50,500円",
            noticeableScratches: "",
            crackedScreen: "~35,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~66,000円",
            someScratches: "~54,500円",
            noticeableScratches: "",
            crackedScreen: "~39,500円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~71,000円",
            someScratches: "~60,000円",
            noticeableScratches: "",
            crackedScreen: "~45,000円",
          },
        ],
      },
      {
        id: 124,
        name: "iphone12 Pro Max",
        spec: [
          {
            id: 1,
            gb: "128GB",
            noScratches: "~75,000円",
            someScratches: "~62,000円",
            noticeableScratches: "",
            crackedScreen: "~47,000円",
          },
          {
            id: 2,
            gb: "256GB",
            noScratches: "~80,000円",
            someScratches: "~67,000円",
            noticeableScratches: "",
            crackedScreen: "~53,000円",
          },
          {
            id: 3,
            gb: "512GB",
            noScratches: "~85,000円",
            someScratches: "~72,000円",
            noticeableScratches: "",
            crackedScreen: "~58,000円",
          },
        ],
      },
    ],
  },
];

export const FAQData = [
  {
    genre: "査定について",
    qa: [
      {
        q: "査定時間はどのくらいですか？",
        a: "最短即日、遅くても翌日には査定を行います。",
      },
      {
        q: "複数台の買取で金額は変わりますか？",
        a: "複数台の買取の場合台数に応じて買取金額をアップさせて頂きます。",
      },
      {
        q: "一度に何台まで買取可能ですか？",
        a: "何台でも歓迎です。買取に出して頂く台数に応じて買取額がアップする仕組みもご用意しております。",
      },
      {
        q: "箱や付属品がなくても買取可能ですか？",
        a: "箱や付属品等がなくても特に買取",
      },
      {
        q: "個人情報（データ）が入った端末は買取可能ですか？",
        a: "個人情報が入っているものの買取は出来ません。",
      },
      {
        q: "端末代金が支払い途中でも買取可能ですか？",
        a: "割賦代金支払い途中であっても問題なく買取可能ですが、赤ロム端末（ネットワーク利用制限が×のもの）に関しては買取出来かねます。",
      },
      {
        q: "買取出来ない端末はありますか？",
        a: "基本的にiPhoneであれば買取可能ですが、赤ロム端末（ネットワーク利用制限×のもの）とiPhoneを探すがオフにできない端末は買取不可能です。",
      },
      {
        q: "未成年の買取受付は出来ますか？",
        a: "18歳以上の方で所定の本人確認書類のアップロードが頂ける方のみ買取可能となっております。",
      },
    ],
  },
  {
    genre: "送料について",
    qa: [
      {
        q: "送料はかかりますか？",
        a: "ご安心ください。送料に関してお客様の負担はございません。",
      },
      {
        q: "査定キャンセルした場合の返送料はかかりますか？",
        a: "査定をキャンセル頂いた場合も返送料などは頂いておりませんのでご安心ください。",
      },
    ],
  },
  {
    genre: "郵送について",
    qa: [
      {
        q: "回収方法を教えてください",
        a: "査定のお申込みを頂き次第弊社より郵送キットをご送付させて頂きますのでデータ初期化を行って頂いてから郵送キットに入れて頂きお近くのポストへ投函をお願い致します。",
      },
      {
        q: "SIMカードを入れたまま送った場合は？",
        a: "SIMカードが入ったまま送って頂くことも可能ですが、弊社到着時にSIMカードが入っていた場合はこちらにて破棄させて頂きます。",
      },
    ],
  },
  {
    genre: "支払い方法について",
    qa: [
      {
        q: "支払い方法は何がありますか？",
        a: "お客様の指定口座にお振込みさせて頂きます。",
      },
      {
        q: "銀行の名義が違う場合、振り込み可能ですか？",
        a: "お振込みの銀行口座に関しましては、アップロード頂く本人確認書類と同名義の口座のみお振込み可能になります。",
      },
      {
        q: "本人確認書類は何が必要ですか？",
        a: "免許証（裏面に住所がある場合は公安印が必要）・マイナンバーカード・健康保険証・学生証（高校生不可）・日本国パスポート（2020年2月3日以前に申請し、日本国で発行され現住所の記載があるもの）・在留カード（住居欄が空欄のものは不可。顔写真があるもの）",
      },
    ],
  },
];
